import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Searchv2Component } from './searchv2.component';
import { CovestroPatternLibraryModule } from '@covestro/pattern-library/dist/ng/aot/src/lib/covestro-pattern-library.module';
import { SearchAppv2Service } from './services/searchv2.service';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
	declarations: [Searchv2Component],
	imports: [
		CommonModule,
		BrowserModule,
		FormsModule,
		HttpClientModule,
		CovestroPatternLibraryModule,
		AppRoutingModule,
	],
	providers: [SearchAppv2Service, { provide: APP_BASE_HREF, useValue: location.pathname }],
	bootstrap: [Searchv2Component],
})
export class Searchv2Module {}
